import React from "react";
import Sample1 from "../components/Sample/Sample1";

const Sample = () => {
  return (
    <div className="w-full flex flex-col items-center ruler">
      <Sample1 />
    </div>
  );
};

export default Sample;
